import React, { Component } from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import { RouteComponentProps, Redirect } from "react-router";
import { IAppState, mapAppStateToProps } from "../../redux/reducers/app";
import { IAppActionDispatches, mapAppDispatchToProps, IAppStoreProps } from "../../redux/actions/app";
// import Page from "../layout/Page";
// import { withCMSContent } from "../cms";
import { IPage } from "../../laco-common/base/models/page";
import { ISiteWidget, getPageWidgets } from "../../models/cms";
import { Widgets } from "../widgets";
import { UIPageTitle } from "../ui/UIPageTitle";
import AppStore from "../ecwid/StoreContext";
// import bg from "../../assets/backgrounds/lacBackground.png";
import bg from "../../assets/backgrounds/imgBg.png";
import { scrollToTop } from "../../utils";
import "./SitePage.scss";

type SitePageProps = {
	page: IPage;
	idPage?: boolean;
	widgets?: ISiteWidget[];
	mergePageProps?: boolean;
};

class SitePage extends Component<SitePageProps & IAppStoreProps & RouteComponentProps> {
	// private readonly handleScroll = debounce(this.onScroll.bind(this), 100, { trailing: true });
	private routeKey: string;
	// private _historySub = null;
	private readonly page: IPage = this.props.page;

	state = {
		widgets: this.props.widgets || [],
		refresh: 0,
	};

	componentDidMount() {
		// SitePage component created for every page - no need
		// this._historySub = this.props.history.listen((location, action) => {
		// 	this.init(location);
		// });
		this.init(this.props.location);
		AppStore.setReactRouter(this.props.history);
	}

	// componentWillUnmount() {
	// 	this._historySub();
	// }

	async init(location) {
		const newRouteKey: string = location.key;
		// if (location && newRouteKey === this.routeKey) return;
		this.routeKey = newRouteKey;
		// if (location.pathname.substr(1) !== this.page.path && !this.props.idPage) return; // dana TODO
		if (!window.location.search && !this.props.idPage) {
			scrollToTop();
		}
		this.props.setCurrentPage(this.page, this.props.idPage || this.props.mergePageProps, this.props.mergePageProps);
		const widgets: ISiteWidget[] = this.props.widgets || (await getPageWidgets(this.page));
		console.log("page widgets:", widgets);
		this.setState({ widgets }); // refresh: this.state.refresh + 1
		document.getElementById("page-styles").innerText = this.page.pageStyles || "";
	}

	render() {
		const page: IPage = this.page;
		if (page.redirectTo) {
			return <Redirect to={page.redirectTo} />;
		}

		return (
			<React.Fragment key={this.props.idPage ? "refresh" : undefined}>
				<UIPageTitle pageTitle={this.props.activePage ? this.props.activePage.metaTitle : ""} />
				<div
					className={clsx(
						"container-fluid",
						`page-${this.props.activePage?.id}`,
						page?.withBackground && "site-page-container-w-background position-relative"
					)}
				>
					{page?.withBackground && <img src={bg} className="site-round-background-image position-absolute" />}
					<main style={{ minHeight: "30vh" }}>
						<Widgets widgets={this.state.widgets} page={this.page} idPage={this.props.idPage} />
					</main>
				</div>
			</React.Fragment>
		);
	}
}

export default connect<IAppState, IAppActionDispatches, SitePageProps>(
	mapAppStateToProps,
	mapAppDispatchToProps
)(SitePage);
